"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oaf_routing_1 = require("oaf-routing");
exports.defaultSettings = Object.assign({}, oaf_routing_1.defaultSettings, { 
    // TODO use `history` to track route IDs and action (POP vs PUSH vs REPLACE)?
    restorePageStateOnPop: false, 
    // We're not restoring page state ourselves so leave this enabled.
    disableAutoScrollRestoration: false });
exports.wrapRouter = (router, settingsOverrides) => {
    const settings = Object.assign({}, exports.defaultSettings, settingsOverrides);
    const oafRouter = oaf_routing_1.createOafRouter(settings, url => {
        // TODO https://caniuse.com/#feat=url
        // return new URL(url).hash;
        const a = document.createElement("a");
        a.href = url;
        return a.hash;
    });
    oafRouter.handleFirstPageLoad(router.route);
    // tslint:disable-next-line: no-let
    let previousRoute = router.route;
    const handleLocationChanged = (url) => {
        // TODO use `history` to track route IDs and action (POP vs PUSH vs REPLACE)?
        const currentLocationKey = undefined;
        const action = undefined;
        oafRouter.handleLocationChanged(previousRoute, url, currentLocationKey, action);
        previousRoute = url;
    };
    router.events.on("routeChangeComplete", handleLocationChanged);
    router.events.on("hashChangeComplete", handleLocationChanged);
    return () => {
        router.events.off("routeChangeComplete", handleLocationChanged);
        router.events.off("hashChangeComplete", handleLocationChanged);
    };
};
